import { ClientInfoSchema } from 'domains/signupDirect/schemas/common';
import { z } from 'zod';

export const resumeSignupLeadSchema = ClientInfoSchema.pick({
  firstName: true,
  lastName: true,
  dateOfBirth: true,
}).extend({
  leadID: z.string(),
});

export type ResumeSignupLeadFormType = Zod.infer<typeof resumeSignupLeadSchema>;
